/*-> Paciente -> Entra a pagina de facturacion -> Ingresa ID de servicio y RFC como primera página antes de entrar al formulario -> Se prellenan los campos con su información incluyendo el RFC que ya proporciono -> Se jala la informacion del servicio -> Se genera la factura. -> Se le enviara la factura al email del paciente.con // Crear cliente fiscalapi*/

import { useState } from 'react'
import ConfirmModal from '../../components/facturas/ConfirmModal'
import StepDatos from '../../components/facturas/StepDatos'
import StepRFC from '../../components/facturas/StepRFC'
import useInvoiceApi from '../../hooks/useInvoiceApi'
// API service layer is available at '../../api' when needed

/**
 * Página principal del proceso de facturación
 * Maneja el estado del wizard de 2 pasos
 */
const Facturas = () => {
  // Estado para controlar el paso actual del wizard
  const [step, setStep] = useState(1)

  // Estado para almacenar los datos del formulario
  const [formData, setFormData] = useState({
    rfc: '',
    serviceCode: '',
    nombreRazonSocial: '',
    codigoPostal: '',
    regimenFiscal: '',
    usoCfdi: '',
    email: '',
  })

  // Estado para controlar la visibilidad del modal de confirmación
  const [showConfirmModal, setShowConfirmModal] = useState(false)

  // Hook personalizado para manejar las peticiones a la API
  const { isLoading, error, success, createInvoice } = useInvoiceApi()

  // Manejador para el paso 1 (RFC y código de servicio)
  const handleStepOneSubmit = data => {
    // Extraer la información del servicio si está disponible
    const { serviceInfo, ...restData } = data

    // Actualizar el estado con los datos y la información del servicio
    setFormData(prev => ({
      ...prev,
      ...restData,
      // Si hay información del servicio, guardarla para usarla después
      descripcion_servicio: serviceInfo?.descripcion || '',
      valor_unitario: serviceInfo?.valor_unitario || 0,
    }))

    setStep(2)
  }

  // Manejador para el paso 2 (datos fiscales)
  const handleStepTwoSubmit = data => {
    setFormData(prev => ({ ...prev, ...data }))
    setShowConfirmModal(true)
  }

  // Manejador para volver al paso anterior
  const handleBack = () => {
    setStep(1)
  }

  // Manejador para cerrar el modal
  const handleCloseModal = () => {
    setShowConfirmModal(false)
  }

  // Manejador para confirmar y enviar la factura
  const handleConfirm = async () => {
    setShowConfirmModal(false)

    // Transformar datos al formato esperado por la API
    const invoiceData = {
      rfc: formData.rfc,
      service_code: formData.serviceCode,
      nombre_razon_social: formData.nombreRazonSocial,
      codigo_postal: formData.codigoPostal,
      regimen_fiscal: formData.regimenFiscal,
      uso_cfdi: formData.usoCfdi,
      email: formData.email,
      descripcion_servicio: formData.descripcion_servicio,
      valor_unitario: formData.valor_unitario,
    }

    // Enviar la petición a la API
    await createInvoice(invoiceData)
  }
  return (
    <div className='min-h-screen bg-gray-50 py-20 px-4'>
      <div className='max-w-4xl mx-auto'>
        <div className='mb-8 text-center'>
          <h1 className='text-3xl font-bold text-primary'>Sistema de Facturación</h1>
          <p className='mt-2 text-gray-600'>Genera tus facturas electrónicas (CFDI) de los servicios recibidos</p>
        </div>

        {/* Indicador de pasos */}
        <div className='mb-8'>
          <div className='flex items-center justify-center'>
            <div className='flex items-center'>
              <div
                className={`rounded-full h-10 w-10 flex items-center justify-center ${
                  step === 1 ? 'bg-primary text-white' : 'bg-primary text-white'
                }`}
              >
                1
              </div>
              <div className={`h-1 w-16 ${step === 1 ? 'bg-gray-300' : 'bg-primary'}`}></div>
              <div
                className={`rounded-full h-10 w-10 flex items-center justify-center ${
                  step === 2 ? 'bg-primary text-white' : 'bg-gray-300 text-gray-600'
                }`}
              >
                2
              </div>
            </div>
          </div>
          <div className='flex justify-center mt-2'>
            <div className='text-center w-28'>Identificación</div>
            <div className='text-center w-28'>Datos fiscales</div>
          </div>
        </div>

        {/* Contenido del paso actual */}
        <div>
          {step === 1 && <StepRFC onContinue={handleStepOneSubmit} initialValues={formData} />}

          {step === 2 && <StepDatos onSubmit={handleStepTwoSubmit} onBack={handleBack} initialValues={formData} />}
        </div>

        {/* Modal de confirmación */}
        <ConfirmModal
          isOpen={showConfirmModal}
          onClose={handleCloseModal}
          onConfirm={handleConfirm}
          factura={formData}
        />

        {/* Mensaje de carga */}
        {isLoading && (
          <div className='mt-8 p-4 bg-blue-50 text-blue-700 rounded-lg text-center'>
            Procesando tu factura, por favor espera...
          </div>
        )}

        {/* Mensaje de error */}
        {error && (
          <div className='mt-8 p-4 bg-red-50 text-red-700 rounded-lg'>
            <p className='font-medium'>Error:</p>
            <p>{error}</p>
          </div>
        )}

        {/* Mensaje de éxito */}
        {success && (
          <div className='mt-8 p-4 bg-green-50 text-green-700 rounded-lg'>
            <p className='font-medium'>¡Factura procesada correctamente!</p>
            <p>{success.message}</p>
            {success.data?.pdf_url && (
              <div className='mt-4'>
                <a
                  href={success.data.pdf_url}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-primary hover:bg-primary/90'
                >
                  Descargar PDF
                </a>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default Facturas
